const state = {
  products: [],
  currentProduct: null,
  categories: [],
  searchQuery: '',
  filters: {}
}

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  SET_CURRENT_PRODUCT(state, product) {
    state.currentProduct = product
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_SEARCH_QUERY(state, query) {
    state.searchQuery = query
  },
  SET_FILTERS(state, filters) {
    state.filters = filters
  }
}

const actions = {
  fetchProducts({ commit }, params) {
    // 这里应该调用API获取产品数据
    // 暂时返回模拟数据
    const mockProducts = [
      {
        id: 1,
        name: '应急通信设备',
        category: '通信设备',
        price: 50000,
        description: '专业应急通信设备',
        image: 'imgs/product1.jpg'
      }
    ]
    commit('SET_PRODUCTS', mockProducts)
  },
  fetchProductById({ commit }, id) {
    // 这里应该调用API获取单个产品数据
    const mockProduct = {
      id: id,
      name: '应急通信设备',
      category: '通信设备',
      price: 50000,
      description: '专业应急通信设备',
      image: 'imgs/product1.jpg'
    }
    commit('SET_CURRENT_PRODUCT', mockProduct)
  }
}

const getters = {
  products: state => state.products,
  currentProduct: state => state.currentProduct,
  categories: state => state.categories
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 